// contexto para almacenar las imagenes de manera globar

import React, { createContext, useState } from 'react'
import { Product } from '../interfaces/definitions/product.interface'

// Define the shape of the context value
interface ProductContextValue {
  product: Product | null
  setProduct: React.Dispatch<React.SetStateAction<Product | null>>
}
// Create the context
export const ProductContext = createContext<ProductContextValue>({
  product: null,
  setProduct: () => {}
})

// Create a provider component
export const ProductProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [product, setProduct] = useState<Product | null>(null)
  return (
    <ProductContext.Provider value={{ product, setProduct }}>
      {children}
    </ProductContext.Provider>
  )
}
